export default function CloseCircle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <g id="close-circle">
        <path
          id="Vector"
          fill="#FF4D4F"
          d="M10 1.25a8.75 8.75 0 1 0 .001 17.501A8.75 8.75 0 0 0 10 1.251m3.23 12.074-1.289-.006L10 11.004l-1.94 2.313-1.29.005a.155.155 0 0 1-.157-.156q.001-.056.037-.101l2.541-3.028-2.54-3.025a.157.157 0 0 1 .12-.258l1.29.006L10 9.074l1.94-2.312 1.289-.006c.086 0 .156.068.156.156a.16.16 0 0 1-.037.102l-2.538 3.025 2.54 3.028q.036.045.037.101c0 .086-.07.156-.157.156"
        ></path>
      </g>
    </svg>
  );
}
